import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex items-center gap-1.5 justify-center",
  "data-test": "button"
}
const _hoisted_2 = { class: "hidden sm:inline-block" }

import { computed } from 'vue'
import useLanguage from '@/composables/useLanguage'
import useRemedyCategoryBackgroundColor from '@/composables/useRemedyCategoryBackgroundColor'
import CollectStormwaterIcon from '@/assets/svg/CollectStormwaterIcon.vue'
import ImprovePublicSpaceIcon from '@/assets/svg/ImprovePublicSpaceIcon.vue'
import ImproveTransitIcon from '@/assets/svg/ImproveTransitIcon.vue'
import PlantVegetationIcon from '@/assets/svg/PlantVegetationIcon.vue'
import RestoreWaterBodyIcon from '@/assets/svg/RestoreWaterBodyIcon.vue'
import AudioIcon from '@/assets/svg/AudioIcon.vue'
import VideoIcon from '@/assets/svg/VideoIcon.vue'
import InfoIcon from '@/assets/svg/InfoIcon.vue'
import { useEventBus } from '@vueuse/core'
import remedyData from '@/assets/data/remedy-data.js'

interface Props {
  category: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RemedyCategoryBadge',
  props: {
    category: null
  },
  setup(__props: any) {

const props = __props as {
  category: string
}


const remedyCategoryText = useLanguage('remedyCategories')
const remedyCategoryIcons = {
  collectStormwater: CollectStormwaterIcon,
  plantVegetation: PlantVegetationIcon,
  improveTransit: ImproveTransitIcon,
  improvePublicSpace: ImprovePublicSpaceIcon,
  restoreWaterBody: RestoreWaterBodyIcon,
  audio: AudioIcon,
  video: VideoIcon,
  info: InfoIcon,
}
const knowledgeBaseBus = useEventBus('open-article')

const categoryTextColor = computed(() => {
  if (props.category == 'restoreWaterBody') {
    return 'text-white'
  } else {
    return 'text-slateGray'
  }
})

const openArticle = (evt) => {
  knowledgeBaseBus.emit(remedyData.remedyCategories[props.category].articleId)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["remedy-category-badge rounded-full cursor-pointer inline-block text-bodyXxs h-6 sm:text-xs mb-1.5 mr-1 px-3 py-1 leading-5 uppercase font-bold tracking-wider", 
      _unref(useRemedyCategoryBackgroundColor)(props.category) + ' ' + _unref(categoryTextColor)
    ]),
    onClick: openArticle
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(remedyCategoryIcons[props.category]))),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(remedyCategoryText)[__props.category]), 1)
    ])
  ], 2))
}
}

})